import ZooxPay from "zoox-pay";
import PersonService from "./person-service";
import CompanyService from "./company-service";
import { ApiClient } from "zoox-infra";

export default class CardService {
  constructor() {
    const personService = new PersonService();
    const companyService = new CompanyService();
    const companyId = companyService.getLocalCompany().id;
    const personId = personService.getPersonId();
    const accessToken = personService.getPersonToken();
    this.zooxPay = new ZooxPay({
      accessToken,
      personId,
      baseUrl: process.env.VUE_APP_ZOOXPAY_BASE_URI,
      companyId: companyId
    });
    this.apiClient = new ApiClient();
  }

  async createCardToken(params) {
    return this.zooxPay.createCardToken(params);
  }

  async getAccessToken() {
    return this.zooxPay.getAccessToken();
  }

  startLoading() {
    const store = this.apiClient.getStore();
    const event = { showLoading: true };
    store.commit("loader/START_LOADING", event);
  }

  finishLoading() {
    const store = this.apiClient.getStore();
    const event = { showLoading: true };
    store.commit("loader/FINISH_LOADING", event);
  }

  async createCard(params) {
    this.startLoading();
    try {
      const response = await this.zooxPay.createCard(params);
      this.finishLoading();
      return response;
    } catch (e) {
      this.finishLoading();
      throw e;
    }
  }

  async deleteCard(cardId) {
    const response = await this.zooxPay.removeCard(cardId);
    return response;
  }

  async getCards() {
    const response = await this.zooxPay.listCards();
    return response.data;
  }
}
